"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("./index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconEyeHideSvg = function IconEyeHideSvg(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    clipRule: "evenodd",
    d: "M19.995.145a.5.5 0 0 0-.706 0l-3.083 3.068C14.766 2.492 13.039 2 10.97 2 5.347 2 2.258 5.65.596 7.615l-.148.186A1.83 1.83 0 0 0 0 9c0 .438.159.863.448 1.197l.159.188c.938 1.109 2.335 2.76 4.388 3.985l-2.79 2.777a.5.5 0 0 0 .705.71l3.005-2.991C7.32 15.543 8.992 16 10.982 16c5.678 0 8.781-3.707 10.45-5.7l.16-.191a1.7 1.7 0 0 0-.011-2.22l-.161-.191c-.926-1.107-2.296-2.743-4.306-3.979l2.88-2.866a.5.5 0 0 0 0-.708zm-4.541 3.816C14.196 3.38 12.716 3 10.97 3 5.85 3 3.029 6.288 1.368 8.25l-.15.189-.013.015A.83.83 0 0 0 1 9c0 .196.07.389.205.543l.006.008.159.187c.973 1.151 2.35 2.766 4.359 3.902L7.878 11.5A4 4 0 0 1 11.015 5a3.993 3.993 0 0 1 2.502.889zM14.21 6.61l2.173-2.163c1.962 1.149 3.311 2.747 4.27 3.893l.167.198.006.007a.7.7 0 0 1 .005.916l-.165.196C18.998 11.649 16.16 15 10.982 15c-1.667 0-3.091-.35-4.311-.888l1.925-1.915a3.995 3.995 0 0 0 3.931.5A4 4 0 0 0 14.21 6.61zm-1.407-.01a3 3 0 0 0-4.21 4.19zm-3.489 4.882l4.177-4.157a3 3 0 0 1-4.177 4.157z",
    fill: "#132122",
    fillRule: "evenodd"
  }));
};

IconEyeHideSvg.defaultProps = {
  fill: "none",
  viewBox: "0 0 22 18",
  xmlns: "http://www.w3.org/2000/svg"
};

var IconEyeHide = function IconEyeHide(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'gray800' : _ref$color,
      measure = _ref.measure,
      rest = _objectWithoutProperties(_ref, ["color", "measure"]);

  return /*#__PURE__*/_react.default.createElement(_index.IconStyled, _extends({
    $color: color,
    $measure: measure
  }, rest), /*#__PURE__*/_react.default.createElement(IconEyeHideSvg, null));
};

IconEyeHide.displayName = 'IconEyeHide';
var _default = IconEyeHide;
exports.default = _default;